<template>
  <div class="employee-dropdown">
    <div class="dropdown-container">
      <div class="dropdown-header" @click="toggleDropdown" :class="{ disabled }">
        <div style="display: flex; align-items: center; justify-content:space-between; gap: 8px; width:100%">
          <div v-if="selectedEmployee" style="margin-top:1px; gap: 6px; display:flex; gap:3; justify-content:center; align-items: center">
            <img
              :src="selectedEmployee.profile_picture || 'static/img/default-dp.png'"
              class="avatar"
            />
            <div class="status" style="margin-left:10px">
              <span class="user-name">{{ selectedEmployee.username }}</span>
            </div>
          </div>
         <div v-else>
          <i class="fa fa-users"></i>
            {{ filterType === "active" ? "Active Employees" : "All Employees" }}
          </div>
        </div>
       <div style=" color: #7b7a7ac7; margin-right:5px; font-size:14px"
        >
          <i  :class="['fa  ', dropdownOpen ? 'fa-chevron-up'  : 'fa-chevron-down']"></i>
        </div>
      </div>
      <div v-if="dropdownOpen" class="dropdown-body">

        <div class="filter-options">
         
          <div
            class="filter-item"
            :class="{ active: filterType === 'all' }"
            @click="setFilter('all')"
          >
            <span>
              <i class="fa fa-users " style="font-size: 16px"></i>
              <span class="filter">  All Employees</span>
            
            </span>
            <span class="count">{{ allEmployees.length }}</span>
          </div>

           <div
            class="filter-item"
            :class="{ active: filterType === 'active' }"
            @click="setFilter('active')"
          >
            <span>
              <i class="fa fa-users"  style="font-size: 16px"></i>
             <span class="filter">Active Employees</span> 
            </span>
            <span class="count">{{ activeEmployees.length }}</span>
          </div>
        </div>

        <input
          v-model="searchTerm"
          type="text"
          class="search-box"
          placeholder="Search employees..."
        />

        <ul class="employee-list">
          <li
            v-for="emp in finalList"
            :key="emp.uid"
            @click="selectEmployee(emp)"
            class="employee-item"
          >
          <div class="item">
            <img
              :src="emp.profile_picture || 'static/img/default-dp.png'"
              class="avatar"
            />
            <div class="status">
              <span class="user-name">{{ emp.username }}</span>
              <span class="small" v-if="!emp.isActive">(inactive)</span>
            </div>
            </div>

            <i
              v-if="selectedEmployee && selectedEmployee.uid === emp.uid"
              class="fa fa-check"
              style="color: green; margin-left: auto; margin-top:-10px"
            ></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmployeeStatusDropdown",
  props: {
    employees: { type: Array, required: true },
    value: { type: String, default: null }, 
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      dropdownOpen: false,
      filterType: "active",
      searchTerm: "",
      selectedEmployee: null, 
    };
  },
  computed: {
    activeEmployees() {
      return this.employees.filter((u) => u.isActive);
    },
    allEmployees() {
      return this.employees;
    },
    finalList() {
      let list = this.filterType === "active" ? this.activeEmployees : this.allEmployees;

      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        list = list.filter(
          (u) =>
            (u.username && u.username.toLowerCase().includes(term)) ||
            (u.email && u.email.toLowerCase().includes(term))
        );
      }

      return list;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.selectedEmployee = this.employees.find((emp) => emp.uid === newValue) || null;
        } else {
          this.selectedEmployee = null;
        }
      },
    },
    selectedEmployee(newValue) {
      this.$emit("input", newValue ? newValue.uid : null);
    },
  },
  methods: {
    toggleDropdown() {
      if (!this.disabled) {
        this.dropdownOpen = !this.dropdownOpen;
      }
    },
    setFilter(type) {
      this.filterType = type;
    },
    selectEmployee(emp) {
      this.selectedEmployee = emp;
      this.dropdownOpen = false;
      this.$emit("input", emp.uid); 
    },
  },
};
</script>

<style scoped>
.employee-dropdown {
  font-size: 14px;
  color: #000000DE !important;
  font-weight: 400 !important;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif !important;
}
.dropdown-container {
  position: absolute;
  z-index: 99;
  width: 260px;
  color: #000000DE !important;
  margin-top: 7px;
  /* margin-top:-2px; */
}
.dropdown-header {
  border-bottom: 1px solid #777777;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:  0px;
  cursor: pointer;
  font-size: 16px;
  height: 45px;
  gap: 0px;
  min-width: 210px;
  color: #000000 !important;
}
.dropdown-header.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.dropdown-body {
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  background: white;
  margin-top: 5px;
  padding: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.filter-options {
  display: flex;
  flex-direction: column;
}
.filter-item {
  padding: 8px 12px;
  cursor: pointer;
  height: 42px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
}
.filter{
    margin-left: 5px;
}
.filter-item.active {
  background: #f0f9f7;
  font-weight: bold;
}
.search-box {
  width: 100%;
  padding: 8px;
  border: none;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  outline: none;
  font-size: 13px;
  height: 42px;
}
.employee-list {
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
}
.employee-item {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0px 8px;
  padding-top: 13px;
  cursor: pointer;
  gap: 10px;
  height: 48px;
}
.item{
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 15px;
  gap: 10px;

}
.employee-item:hover {
  background: #f9f9f9;
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.status {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-left: 10px;
  gap: 8px;
}
.small {
  font-size: 8px;
  margin-top: -5px
}
.count {
  background: #5ec1a6;
  color: white;
  font-size: 8px;
  min-width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  border-radius: 12px;
}
.dropdown-caret {
  display: inline-block;
  margin-top:15px;
  margin-right: 3px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.dropdown-caret.down {
  border-top: 5px solid #555;
}

.dropdown-caret.up {
  border-bottom: 5px solid #555;
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/EmployeeStatusDropdown.vue